import { render, staticRenderFns } from "./SubEmpresaBlocoInserirCodigoExterno.vue?vue&type=template&id=866164d8&scoped=true&lang=pug"
import script from "./SubEmpresaBlocoInserirCodigoExterno.vue?vue&type=script&lang=js"
export * from "./SubEmpresaBlocoInserirCodigoExterno.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaBlocoInserirCodigoExterno.vue?vue&type=style&index=0&id=866164d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866164d8",
  null
  
)

export default component.exports